module.exports = __webpack_public_path__ + "static/Alert-level-7daf267dc2be888e1974fbf50b600823.png";